<template>
   <section class="gurantee-full-wrap new-full-about strong-section p-0">
        <div class="barana-img"><img alt="" class="w-100" src="/assets/images/new_home/cymslim-Image1.jpg"></div>
        <div class="barana-text">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12 ms-md-auto aos-init aos-animate" data-aos="fade-right">
                    <h2>Struggling with Weight Loss Despite Eating Less?</h2>

                    <p><b>“I’m barely eating, but the scale won’t budge.” </b> <br> Drastically cutting calories often leads to water retention and a sluggish metabolism—not fat loss.</p>

                    <p><b>“I feel tired, bloated, and low on energy.” </b> <br> Inflammation and toxin buildup can make your body feel heavy, drained, and resistant to change. </p>

                    <p><b>“No matter what I try, my body just doesn’t respond.”</b> <br> Hidden oxidative stress and poor detox can block your fat-burning potential.</p>

                    <h3>Why CYMSLIM Help You Lose Weight (When Eating Less Doesn’t)</h3>
                    <p><b>Eating less isn’t always the answer.</b> Severely cutting calories can trigger water retention and slow your metabolism. CYMSLIM helps energize your cells to burn more fat—naturally.</p>

                    <p><b>Flush out water weight and toxins</b> CYMSLIM supports liver detox, helping your body release excess water and waste.</p>

                    <p><b>Boost fat-burning metabolism naturally</b> CYMSLIM’s primary ingredient, glutathione precursors power up your mitochondria—the body’s fat-burning engines.</p>

                    <p><b>Reduce inflammation that blocks weight loss </b> Lower oxidative stress so your body can focus on shedding fat, not fighting internal stress.</p>

                    <p><b>Feel more energized,</b> not deprived Say goodbye to fatigue from dieting. These nutrients help fuel your day and keep cravings in check.</p>

                    
                    </div>
                </div>

            </div>
        </div>
    </section>
    <!-- <section class="products-related-gsh complex-sec2">
        <div class="container-fluid">
            <div class="row" data-aos="fade-up">
                <div class="col-md-6 mb-4 mb-md-0"><img src="/assets/images/new_home/cymslim-Image2.jpg" alt=""></div>
                <div class="col-md-6">
                    <h2>Why Choose Our CYMSlim Weight Loss Program?</h2>
                    <p>Are you tired of weight loss programs that overpromise and underdeliver? Our CYMSlim Weight Management Program (WMP) takes a completely different approach – no meal replacements, no crash diets, and no gimmicks. Just powerful, science-backed products designed to work at the cellular level for real, lasting results.</p>
                </div>
            </div>
        </div>
    </section> -->
  </template>
  
  <script setup>
  import { ref, computed, defineProps, onUpdated, onMounted } from "vue";
  import { useLoginStore } from "../../stores/login";
  import { useCartStore } from "../../stores/cart";
  import { userLanguage } from "../../stores/language";
  import { onBeforeRouteLeave, onBeforeRouteUpdate } from "vue-router";
  import $ from "jquery";
  const userLogin = useLoginStore();
  const cartData = useCartStore();
  const userLanguages = userLanguage();
  const token = ref("");
  const props = defineProps(["baseURL", "translationText"]);
  const siteFooterLegal = ref([]);
  const defaultLanguage = ref("");
  
  onMounted(() => {
    
  });
  
  onUpdated(() => {});
  </script>
  